export default __webpack_public_path__ + "static/media/illustration-algostudy-m.c80d6764.webp";